import Context from './Context.js';
import StringHelper from '../helpers/StringHelper.js';

export default class Dealer extends Context {
  constructor(groupHash, franchiseHash, locationHash, brandName, gsh, host) {
    super();
    this.data = {
      de_gr: groupHash,
      de_br: StringHelper.toLowerCase(brandName),
      de_fr: franchiseHash,
      de_lo: locationHash,
      de_gs: gsh,
      de_ho: host,
    };
  }

  static get key() {
    return 'dealer_event_context';
  }

  static get version() {
    return '1-1-0';
  }
}
